/**
 * SettingsHeader — shared header pattern for every Settings tab.
 *
 * Renders the section title + optional subtitle on the left, and an
 * optional action zone (buttons) on the right. Matches the established
 * `settings-section-title` / `settings-section-subtitle` typography so
 * every tab feels congruent.
 */
import React from 'react';

const SettingsHeader = ({ title, subtitle, children }) => (
  <div className="flex items-start justify-between gap-3 mb-3">
    <div className="min-w-0">
      <h2 className="settings-section-title">{title}</h2>
      {subtitle && <p className="settings-section-subtitle">{subtitle}</p>}
    </div>
    {children && <div className="flex items-center gap-2 flex-shrink-0">{children}</div>}
  </div>
);

export default SettingsHeader;
